import { axiosInstance, requestConfig } from 'network/apis';

import { URL_GAME } from 'utils/constants';

export const callScorecardInfo = async (gameRoundId, data) => {
    return await axiosInstance(requestConfig('get', URL_GAME, `/scorecard/${gameRoundId}`, data));
};
